export default class FKegiatanMaterial {
  constructor(
    id,
    description  ="",

    fdivisionBean  = 0,
    fvendorBean  = 0,
    fmaterialBean = 0,

    tanggal = 2021,
    satuan = "",
    price = 0.0,

    created,
    modified,
    modifiedBy
  ) {

    this.id = id;

    this.description = description;

    this.fdivisionBean = fdivisionBean;
    this.fvendorBean = fvendorBean;
    this.fmaterialBean = fmaterialBean;

    this.tanggal = tanggal;
    this.satuan = satuan;
    this.price = price;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
